export enum MerchantCredentialQueryKeys {
  GET_MERCHANT_CREDENTIAL_LIST = 'GET_MERCHANT_CREDENTIAL_LIST',
  GET_MERCHANT_CREDENTIAL_DETAIL = 'GET_MERCHANT_CREDENTIAL_DETAIL',
}
